/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React from 'react';

import CurrencySign from 'components/price/CurrencySign.component';

import BookingDescription from 'clientProfile/components/bookingHistory/BookingDescription';
import ConversationDetailsComponent from 'clientProfile/components/common/ConversationDetails';
import { calculateTotalPrice } from 'clientProfile/utils';

const ScheduledBookingDescription = (props) => (
  <div className="scheduler-booking 2">
    <BookingDescription
      appointment={props.appointment}
      onAppointmentClick={props.onScheduledAppointmentClick}
      detailsView
    />
    <dl className="dl-horizontal cfix">
      <dt>Deposit Paid</dt>
      <dd>
        -<CurrencySign />
        {props.appointment.deposit_paid || 0}
      </dd>
      <dt>Total</dt>
      {props.appointment.procedures && (
        <dd className="f-b">
          <CurrencySign value={calculateTotalPrice(props.appointment.procedures)} />
        </dd>
      )}
      {props.appointment.price && (
        <dd className="f-b">
          <CurrencySign value={props.appointment.price} />
        </dd>
      )}
    </dl>

    <ConversationDetailsComponent
      notes={props.appointment.notes}
      smsRecords={props.appointment.sms_records}
      smsRemindersOn={props.smsRemindersOn}
    />
  </div>
);

export default ScheduledBookingDescription;
